import { i as r } from "./is-array.js";
import { i as o } from "./is-constructor.js";
import { i as s } from "./is-object.js";
import { w as i } from "./well-known-symbol.js";
var t = i("species"),
  a = Array,
  c = function c(i) {
    var c;
    return r(i) && (o(c = i.constructor) && (c === a || r(c.prototype)) ? c = void 0 : s(c) && null === (c = c[t]) && (c = void 0)), void 0 === c ? a : c;
  };
export { c as a };